import React from "react";
import { useState } from "react";
import logo from "../images/logo.png";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [toggle, setToggle] = useState();
  const changeToggle = (index) => {
    setToggle(index);
  };

  const openGooglePlay = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.trinet_wallet",
      "_blank"
    );
  };

  return (
    <>
      <nav className="mx-auto flex items-center justify-between gap-x-6 p-6 max-w-screen lg:px-8 fixed top-0 left-0 bg-white w-[100vw] lg:h-28 h-24  z-50">
        <div className="flex">
          <a
            className="-m-1.5 p-1.5 text-white flex justify-center items-center "
            href="/"
          >
            <span className="sr-only">Your Company</span>
            <img src={logo} className="w-24 h-24" />
            <span className="text-[#fcc204] font-black text-3xl ">
              Trinet Wallet
            </span>
          </a>
        </div>
        <div className="hidden gap-x-6 lg:flex xl:gap-x-12 justify-center items-center">
          <a
            
            className="text-black capitalize font-normal text-sm xl:text-base hover:text-sky-600"
            
          >
            Wallet
          </a>
          <a className="text-black capitalize font-normal text-sm xl:text-base hover:text-sky-600">
            features
          </a>
          <a className="text-black capitalize font-normal text-sm xl:text-base hover:text-sky-600">
            Build
          </a>
          <a className="text-black capitalize font-normal text-sm xl:text-base hover:text-sky-600">
            Support
          </a>
          <a
            href="https://triqubenetwork.com/"
            target="_blank"
            className="text-black capitalize font-normal text-sm xl:text-base hover:text-sky-600"
          >
            About
          </a>

          {/* <button className="rounded-full px-4 py-2   text-white shadow-sm blue border-none font-semibold border border-neutral-500 capitalize text-base ">
								download
							</button> */}

          <button
            className={`w-max flex justify-center items-center blue  relative serviceCardAnimation  overflow-hidden rounded-full  duration-500 ${
              toggle === 1 ? "text-black" : "text-white"
            }`}
            onClick={openGooglePlay}
            onMouseOver={() => changeToggle(1)}
            onMouseOut={() => changeToggle(0)}
          >
            <h5 className="w-full h-full bg-sky-500 z-0 rounded-full"></h5>

            <h1 className="z-50 bg-transparent text-[1rem] px-[1.5rem] py-[0.45rem] font-medium duration-300">
              Download
            </h1>
          </button>
        </div>
        <div className="flex lg:hidden">
          <button
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-black"
            onClick={() => {
              setOpen(!open);
            }}
          >
            <span className="sr-only">Open main menu</span>
            <span className="w-fit">
              <svg
                className="h-8 w-8"
                fill="#000"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                ></path>
              </svg>
            </span>
          </button>
        </div>
      </nav>
      {open && (
        <div className="lg:hidden">
          <div className="fixed inset-y-0 right-0 z-50 sm:w-full w-[100vw] h-[100vh] bg-black px-6 py-4 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
            <div className="w-full h-full flex justify-beetween items-center  flex-col">
              <div className="w-full flex justify-start items-start  flex-col">
                <div className="gap-x-6 w-full flex justify-between items-center flex-row">
                  <a className="-m-1.5 p-1.5 text-white" href="/">
                    <span className="sr-only">Your Company</span>
                    <img src={logo} className="w-20 h-20" />
                  </a>
                  <button
                    className="-m-2.5 rounded-md p-2.5 text-white"
                    onClick={() => {
                      setOpen(!open);
                    }}
                  >
                    <span className="sr-only">Close menu</span>
                    <span className="w-fit">
                      <svg
                        className="h-8 w-8"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M6 18L18 6M6 6l12 12"
                        ></path>
                      </svg>
                    </span>
                  </button>
                </div>
                <div className="mt-6 flow-root w-full justify-start items-start flex-col">
                  <div className="-my-6 divide-y divide-gray-500/10 w-full">
                    <div className="space-y-2 py-6 w-max">
                      <a
                        
                        className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-white hover:text-sky-600 "
                        
                        onClick={() => {
                          setToggle(!toggle);
                        }}
                      >
                        Wallet
                      </a>
                      <a
                        
                        className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-white hover:text-sky-600"
                        
                        onClick={() => {
                          setToggle(!toggle);
                        }}
                      >
                        features
                      </a>
                      <a
                        className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-white hover:text-sky-600"
                        onClick={() => {
                          setToggle(!toggle);
                        }}
                      >
                        Build
                      </a>
                      <a
                        className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-white hover:text-sky-600"
                        onClick={() => {
                          setToggle(!toggle);
                        }}
                      >
                        Support
                      </a>
                      <a
                        href="https://triqubenetwork.com/"
                        target="_blank"
                        className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-white hover:text-sky-600"
                        onClick={() => {
                          setToggle(!toggle);
                        }}
                      >
                        About
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className=" w-full flex  flex-1 items-center gap-x-6 py-6 mb-10 ">
                <button
                  className={`sm:w-max w-full flex justify-center items-center blue  relative serviceCardAnimation  overflow-hidden rounded-full  duration-500 ${
                    toggle === 1 ? "text-black" : "text-white"
                  }`}
                  onMouseOver={() => changeToggle(1)}
                  onMouseOut={() => changeToggle(0)}
                >
                  <h5 className="w-full h-full bg-sky-500 z-0 rounded-full"></h5>
                  <h1 className="z-50 bg-transparent text-[1rem] px-[1.5rem] py-[0.45rem] font-medium duration-300">
                    Download
                  </h1>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
